import { Location } from "core/src/ports/navigation-service.interface";

export type NavigationState = {
	location: Location;
};

const navigationReducerInit = (): NavigationState => ({
	location: {
		pathname: "",
		search: "",
		hash: "",
		state: null,
		key: "",
	},
});

export const initialNavigationState = navigationReducerInit();
